import { useTranslation } from 'next-i18next';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { A, Box, ButtonV2 as Button } from '@bridebook/ui';
import { IconExport, IconFacebook, IconInstagram } from '@bridebook/ui/src/icons';
import { formatUrl } from '@bridebook/web/app-shared/lib/supplier/utils/formatUrl';
import getUtmParams from '@bridebook/web/app-shared/lib/utils/get-utm-params';
import componentStyles from './social-bar.style';

interface IProps {
  isMobile: boolean;
  supplier: ISupplier;
  isShareButtonEnabled: boolean;
  onShareClick?: () => void;
  onSocialClick?: (
    e: React.MouseEvent<React.ReactNode | Element>,
    title: string,
    url: string,
  ) => void;
  onWebsiteClick?: (e: React.MouseEvent<React.ReactNode | Element>, url: string) => void;
  isVisitWebsiteCTAEnabled?: boolean;
}

const SocialBar = ({
  isShareButtonEnabled,
  onShareClick,
  onSocialClick,
  onWebsiteClick,
  supplier,
  isVisitWebsiteCTAEnabled = true,
}: IProps) => {
  const { t } = useTranslation('supplier');
  const styles = componentStyles();
  const supplierWebsiteUrl = formatUrl(supplier?.contacts?.website, getUtmParams('profile'));
  const supplierInstagramUrl = formatUrl(supplier?.social?.instagram);
  const supplierFacebookUrl = formatUrl(supplier?.social?.facebook);

  return (
    <Box style={styles.wrapper}>
      {supplierWebsiteUrl && isVisitWebsiteCTAEnabled && (
        <A
          noUnderline
          color="mint"
          href={supplierWebsiteUrl}
          onClick={(e) => onWebsiteClick?.(e, supplierWebsiteUrl)}
          rel="noopener nofollow"
          target="_blank">
          <Button styleButton={styles.link} variant="link">
            {t('socialBar.visitWebsite')}
          </Button>
        </A>
      )}
      <Box style={styles.iconWrapper}>
        {isShareButtonEnabled && (
          <Button
            variant="ghost"
            styleWrapper={styles.icon}
            onClick={onShareClick}
            endIcon={<IconExport width={16} />}
          />
        )}
        {supplierInstagramUrl && (
          <A
            noUnderline
            href={supplierInstagramUrl}
            target="_blank"
            style={styles.icon}
            onClick={(e) => onSocialClick?.(e, 'instagram', supplierInstagramUrl)}>
            <IconInstagram width={20} />
          </A>
        )}
        {supplierFacebookUrl && (
          <A
            noUnderline
            href={supplierFacebookUrl}
            target="_blank"
            style={styles.icon}
            onClick={(e) => onSocialClick?.(e, 'facebook', supplierFacebookUrl)}>
            <IconFacebook width={10} />
          </A>
        )}
      </Box>
    </Box>
  );
};

export default SocialBar;
